import { LearningResourceFeeDto } from './learningresourcefeedto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class LearningResourceFeeRequest {

    learningResourceFeeDto: LearningResourceFeeDto = new LearningResourceFeeDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}